export const NATIONAL_CALENDAR_FALLBACK = 'NATIONAL_CALENDAR_FALLBACK'
export const CALENDAR_FALLBACK_TOOLTIP = 'Calendário do tribunal indisponível. Vencimento calculado com fins de semana e feriados nacionais.'

const field = (source, key) => source?.[key] ?? source?.[key.charAt(0).toUpperCase() + key.slice(1)]

export function isNationalCalendarFallbackEvidence(evidence) {
  return field(evidence, 'type') === NATIONAL_CALENDAR_FALLBACK
}

export function hasNationalCalendarFallback(source) {
  return field(source, 'calendarFallbackUsed') === true
    || (Array.isArray(field(source, 'evidence')) && field(source, 'evidence').some(isNationalCalendarFallbackEvidence))
}

export function taskCalendarFallbackUsed(task, deadlines = []) {
  if (hasNationalCalendarFallback(task)) return true
  const action = field(task, 'actionCode')
  const date = field(task, 'dueDate')
  if (!action || !date) return false
  return deadlines.some((deadline) => field(deadline, 'actionCode') === action && field(deadline, 'dueDate') === date
    && hasNationalCalendarFallback(deadline))
}
